var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.accepted)?_c('div',[_c('p',[_vm._v("招待を受け入れました。")]),_c('b-link',{attrs:{"to":"/"}},[_vm._v("\n    ダッシュボードに戻る\n  ")])],1):_c('ReceiveInvitation',{attrs:{"inviteCode":_vm.inviteCode,"errors":_vm.errors},on:{"accept":_vm.accept}})}
var staticRenderFns = []

export { render, staticRenderFns }